export const userCollection = 'mcl-users';
export const shoppingListCollection = 'shoppingLists';
